define([
    'underscore',
    'edge/platform/widgets/wizard/_WizardStepsCtrl',
    'text!edge/platform/widgets/wizard/templates/wizard-sidebar-ribbon.html'
], (_, _WizardStepsCtrl, templateStr)=> {
    return function () {
        return {
            restrict: 'A',
            replace: true,
            template: templateStr,
            controller: _WizardStepsCtrl,
            scope: {
                title: '@'
            }
        };
    };
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/wizard/WizardSidebarRibbonDirective.js